/* eslint-disable */

const ns = 'RAI_ANALYTICS_SOCI_';

export const REQUEST_READ_ALL_ASSIGNEMENTS = `${ns}REQUEST_READ_ALL_ASSIGNEMENTS` ;
export const READ_ALL_ASSIGNEMENTS_ERROR = `${ns}READ_ALL_ASSIGNEMENTS_ERROR`;
export const READED_ALL_ASSIGNEMENTS =  `${ns}READED_ALL_ASSIGNEMENTS`;
